/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div class="store_login_unit">{{brandStoreName}}</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="admin_menu_top_unit menu_center">

                <Message v-if="ApivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />

                <form class="form_store"  v-on:submit.prevent="onsubmit">
                    <div class="lavel_store right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="storename">店舗名</label>
                    </div>
                    <div class="input_store left_comment">
                        <input class="wd400" id="storename" name="storename" type="text" v-model="storeContent.storeName" maxlength="20"/><br>
                        <label id="storenameerror" class="lavel_error_font ">{{validation.storenameResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="storepostalcode">郵便番号</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd240" id="storepostalcode" name="storepostalcode" type="text" v-model="storeContent.zipCode" maxlength="7"/><br>
                        <label>半角数字(ハイフンなし)で入力してください。</label>
                        <label id="storepostalcodeerror" class="lavel_error_font ">{{validation.zipcodeResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="storeaddress">店舗住所</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd400" id="storeaddress" name="storeaddress" type="text" v-model="storeContent.address" maxlength="40"/><br>
                        <label id="storeaddresserror" class="lavel_error_font ">{{validation.addressResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storeｒemarks">備考欄</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd400" id="storeｒemarks" name="storeｒemarks" type="text" v-model="storeContent.remarks" maxlength="20"/><br>
                        <label id="storeｒemarkserror" class="lavel_error_font ">{{validation.remarksResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="storetell">連絡先電話番号</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd240" id="storetell" name="storetell" type="text" v-model="storeContent.phoneNumber" maxlength="11"/><br>
                        <label>半角数字(ハイフンなし)で入力してください。</label>
                        <label id="storetellerror" class="lavel_error_font ">{{validation.phonenumberResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storetell">アラート通知先</label>
                    </div>
                    <div class="input_store left_comment">
                      <div v-for="(email, index) in storeContent.anomalyMail" :key="index" class="d-flex align-items-start mgb_10">
                        <input  class="wd240" :id="'storeanomalymail'+index" name="storeanomalymail" type="text" v-model="storeContent.anomalyMail[index]"/>
                        <div v-if="index == 0" class="storeSetting_kanri_box ">
                          <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="addColum">枠追加</a></li></ul>
                        </div>
                        <div v-if="index != 0" class="storeSetting_kanri_box ">
                          <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="deleteColum(index)">削除</a></li></ul>
                        </div>
                        <label id="storeanomalymailerror" class="lavel_error_font ">{{validation.anomalymailResult[index]}}</label>
                      </div>
                    </div>

                    <div class="lavel_store right_comment">
                        <img class="required" src="../assets/required.png" />
                        <label for="storperson">店舗管理者氏名</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd240" id="storperson" name="storperson" type="text" v-model="storeContent.adminName" maxlength="20"/><br>
                        <label id="storpersonerror" class="lavel_error_font ">{{validation.adminnameResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storenowpass">現在の店舗管理者パスワード</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd240" id="storenowpass" name="storenowpass" type="password" v-model="editStoreForm.current_password" maxlength="128"/><br>
                        <label id="storenowpasserror" class="lavel_error_font ">{{validation.storenowpassResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storepass">新しい店舗管理者パスワード</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd240" id="storepass" name="storepass" type="password" v-model="editStoreForm.password" maxlength="128"/><br>
                        <label>8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                        <label id="storepasserror" class="lavel_error_font ">{{validation.storeypassResult}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storepass2">新しい店舗管理者パスワード(確認)</label>
                    </div>
                    <div class="input_store left_comment">
                        <input  class="wd240" id="storepass2" name="storepass2" type="password" v-model="editStoreForm.password_confirm" maxlength="128"/><br>
                        <label id="storepass2error" class="lavel_error_font ">{{validation.storerepassResult}}</label>
                    </div>

                </form>
            </div>
            <div class="btn_submit letter_spa">
                <a href="#" @click.prevent.stop="checkFrom">更新</a>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">店舗更新</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>店舗更新が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'StoreEdit',
    components: {
        PulseLoader,
        Message
    },
    props:{
        id:Number,
    },
    data: function () {
        return {
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            isLoading:false,
            isInitLoading:true,
            brandId: '',
            storeId: '',
            showContent:false,
            storeContent: {},
            editStoreForm: {
                current_password: '',
                password: '',
                password_confirm: ''
            },
            validation:{
                storenameResult: "",
                zipcodeResult: "",
                addressResult: "",
                remarksResult: "",
                phonenumberResult: "",
                anomalymailResult: [],
                adminnameResult: "",
                storenowpassResult: "",
                storeypassResult: "",
                storerepassResult: "",
            },
            addFormFlg: true
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    },
    async created() {

        //ブランドIDを取得
        this.brandId = this.$store.getters['manager/manager'].brandId;
        //権限情報を取得
        this.auth = this.$store.getters['manager/manager'].authorityKbn;
        //ストアIDを取得
        this.storeId = this.$store.getters['store/id'];

        var params = {}

        if(this.auth == 3 || this.auth == 4) {
            //ストアIDを取得
            this.storeId = this.$store.getters['store/id'];
            params.store_id = this.storeId;
        }

        // 管理画面店舗情報取得API
        await this.$axios
            .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId)
            .then(response => {
              this.storeContent = response['data']['storeData'];
              if(this.storeContent.anomalyMail.length == 0) {
                this.storeContent.anomalyMail.push('')
              }
            })
            .catch((err) => {
                let error = {
                    button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                    }}

                if (err.customError.code == 401) {
                    //店舗管理者のtokenエラーの場合
                    this.$cookies.set('user-api-token', '', 0)
                    this.$store.dispatch('store/doClear')
                }
                if (err.customError) {
                    error = Object.assign(error, err.customError)
                }
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }).finally(()=> this.isInitLoading = false);

    },
    methods:{
        checkFrom: async function(){

            this.addFormFlg = true;
            this.isLoading = true;

            //エラー内容初期化
            this.clearError();

            //バリデーションチェック(企業コード)
            //必須チェック
            if(!this.storeContent.storeName){
                this.validation.storenameResult="店舗名を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.storeContent.zipCode){
                this.validation.zipcodeResult="郵便番号を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.storeContent.address){
                this.validation.addressResult="店舗住所を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.storeContent.phoneNumber){
                this.validation.phonenumberResult="連絡先電話番号を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.storeContent.adminName){
                this.validation.adminnameResult="店舗管理者氏名を入力してください。"
                this.addFormFlg = false;
            }
            // 条件必須
            // パスワード
            if(this.editStoreForm.password !== "" || this.editStoreForm.password_confirm !== ""){
                if(this.editStoreForm.current_password == ""){
                    this.validation.storenowpassResult="現在の店舗管理者パスワードを入力してください。"
                    this.addFormFlg = false;
                }
            }

            //桁数チェック
            if(String(this.storeContent.storeName).length > 20 && this.validation.storenameResult ==""){
                this.validation.storenameResult="店舗名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.storeContent.zipCode).length !== 7 && this.validation.zipcodeResult == ""){
                this.validation.zipcodeResult="郵便番号は7桁で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.storeContent.address).length > 40 && this.validation.addressResult == ""){
                this.validation.addressResult="店舗住所は40桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.storeContent.remarks).length > 20 && this.validation.remarksResult == ""){
                this.validation.remarksResult="備考欄は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if((String(this.storeContent.phoneNumber).length < 10 || String(this.storeContent.phoneNumber).length > 11) && this.validation.phonenumberResult == ""){
                this.validation.phonenumberResult="連絡先電話番号は10桁以上11桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.storeContent.adminName).length >20 && this.validation.adminnameResult == ""){
                this.validation.adminnameResult="店舗管理者氏名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.editStoreForm.password !== ''){
                if(String(this.editStoreForm.password).length < 8 || String(this.editStoreForm.password).length > 128
                    && this.validation.storeypassResult == ""){
                    this.validation.storeypassResult="店舗管理者パスワードは8桁以上、128桁以内で入力してください。"
                    this.addFormFlg = false;
                }
            }


            //文字種チェック
            if(this.storeContent.storeName !== null && !this.checkStrong2(this.storeContent.storeName) && this.validation.storenameResult == ""){
                this.validation.storenameResult="店舗名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.storeContent.zipCode !== null && !this.checkNumberZipCode(this.storeContent.zipCode) && this.validation.zipcodeResult == ""){
                this.validation.zipcodeResult="郵便番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.storeContent.address !== null && !this.checkAddress(this.storeContent.address) && this.validation.addressResult == ""){
                this.validation.addressResult="店舗住所は全半角英数漢ひらカナ記号（・ー-）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.storeContent.remarks !== null && !this.checkStrong2(this.storeContent.remarks) && this.validation.remarksResult == ""){
                this.validation.remarksResult="備考欄は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.storeContent.phoneNumber !== null && !this.checkNumber(this.storeContent.phoneNumber) && this.validation.phonenumberResult == ""){
                this.validation.phonenumberResult="連絡先電話番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.storeContent.adminName !== null && !this.checkStrong2(this.storeContent.adminName) && this.validation.adminnameResult == ""){
                this.validation.adminnameResult="店舗管理者氏名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.editStoreForm.password!== '' && !this.checkStrong4(this.editStoreForm.password) && this.validation.storeypassResult == ""){
                this.validation.storeypassResult="管理者パスワードは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }

            //pwチェック
            if(this.editStoreForm.password !== "" || this.editStoreForm.password_confirm !== ""){
                if(this.editStoreForm.password !== this.editStoreForm.password_confirm && this.validation.storeypassResult == ""){
                    this.validation.storeypassResult="パスワードが一致しません。入力しなおしてください。"
                    this.addFormFlg = false;
                }
            }

            // バリデーション
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            if(this.addFormFlg == true){

                var apiResponseFlg = true;

                var requestStoreContent = {
                    store_name: this.storeContent.storeName,
                    zip_code: this.storeContent.zipCode,
                    address: this.storeContent.address,
                    remarks: this.storeContent.remarks,
                    phone_number: this.storeContent.phoneNumber,
                    admin_name: this.storeContent.adminName,
                    anomaly_mail: this.storeContent.anomalyMail

                }
                var requestEditStoreForm = {
                    current_password: this.editStoreForm.current_password,
                    new_password: this.editStoreForm.password,
                    new_password_confirm: this.editStoreForm.password_confirm
                }
                var body = Object.assign(requestStoreContent, requestEditStoreForm);
                // 店舗情報の更新
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/'  + this.storeId + '/update', body)
                    .then(response => (this.storeContent = response['data']['storeUpd']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }

                            if (error.code == 401) {
                                // 認証エラーの場合は店舗情報を削除して再ログインさせる
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);
                if(apiResponseFlg){
                    this.$store.dispatch('store/doUpdate',{data: this.storeContent, brandId: this.brandId})
                    this.openModel()
                }
            }

        },
        //半角英数字のチェック
        checkStrong:function(inputdata){
            var re = new RegExp(/^[A-Za-z0-9]*$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumber:function(inputdata){
            var re = new RegExp(/^[0-9]*$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumberZipCode:function(inputdata){
            var re = new RegExp(/^[0-9]{7}$/);
            return re.test(inputdata);
        },
        //全半角英数漢ひらカナ
        checkStrong2:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpace);
            return re.test(inputdata);
        },
        //半角英数記号
        checkStrong4:function(inputdata){
            var re = new RegExp(/^[0-9a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/);
            return re.test(inputdata);
        },
        //住所（全半角英数漢ひらカナ記号（・ー-））
        checkAddress:function(inputdata){
            var re = new RegExp(ValidationRule.Address);
            return re.test(inputdata);
        },
        clearError:function(){
            //メッセージ初期化
            this.validation.storenameResult = "";
            this.validation.zipcodeResult = "";
            this.validation.addressResult = "";
            this.validation.remarksResult = "";
            this.validation.phonenumberResult = "";
            this.validation.adminnameResult = "";
            this.validation.storeypassResult = "";
            this.validation.storerepassResult = "";
            this.ApivalidationMessage = "";
            this.validation.storenowpassResult = "";
            this.validation.anomalymailResult = [];
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'manageStoreList', params: {brandPath: this.brandPath}});
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        addColum(){
            if(this.storeContent.anomalyMail.length < 15) {
              this.storeContent.anomalyMail.push('')
            }
        },
        deleteColum(index){
          this.storeContent.anomalyMail.splice(index,1);
        }
    }
}
</script>